export default {
    deviceName: "设备名称",
    deviceSN: "设备SN",
    addedRobotDog: "新增机器狗",
    editRobotDog: "编辑机器狗",
    online: "在线",
    offline: "离线",
    standingMode: "站立模式",
    lockMode: "锁定模式",
    enterMonitoring: "进入监控",
    bindingCode: "绑定码",
    name: "名称",
    lockedState: "锁定状态",
    unlockedState: "解锁状态",
    endStreaming: "结束推流",
    startStreaming: "开始推流",
    emergencyStop: "急停",
    lookUp: "抬头",
    rotateLeft: "左旋转",
    bowYourHead: "低头",
    rotateRight: "右旋转",
    goAhead: "前进",
    shiftLeft: "左移",
    back: "后退",
    shiftRight: "右移",
    pointCloudModeling: "点云建模",
    stopModeling: "停止建模",
    startModeling: "开始建模",
    pointCloudDownload: "点云下载",
    stopCopying: "停止拷贝",
    startCopying: "开始拷贝",
    returnToRobotDogList: "返回机器狗列表",
    getDown: "趴下",
    stand: "站立",
    mobileMode: "移动模式",
    inPlaceMode: "原地模式",
    bodyElevation: "身体抬高",
    turnLeft: "原地左转",
    bodyLowered: "身体降低",
    turnRight: "原地右转",
    leftLeaning: "左倾",
    rightLeaning: "右倾",
    tip_PETDN: "请输入设备名称",
    tip_PETDS: "请输入设备SN",
    tip_PETRDS: "请输入机器狗SN",
    tip_PETBC: "请输入绑定码",
    tip_PETNO: "请输入机器狗名称",
    tip_TRDIC: "当前机器狗为锁定状态，点击可解锁",
    tip_TRDICU: "当前机器狗为解锁状态，点击可锁定",
    tip1: "点云模型生成中，请移动机器狗",
    tip2: "请将U盘插入机器狗",
    tip3: "当前机器狗为趴下状态，点击可站立",
    tip4: "当前机器狗为站立状态，点击可趴下",
    tip5: "当前机器狗为移动模式，点击可切换到原地模式",
    tip6: "当前机器狗为原地模式，点击可切换到移动模式",
};
